<template>
  <div v-if="(!loaded)" class="loading-spinner"></div>
  <div v-if="(loaded)">
    <div class="solucoes-view">
      <div class="page-title" style="background-color: #000;">
        <div class="auto-container">
          <div class="titulo white" v-html="fc_removeHTML(item.titulo)"></div>
        </div>
      </div>
      <div class="page-text" v-if="(item.subtitulo != null && fc_removeHTML(item.subtitulo).trim() !== '')">
        <div class="auto-container">
          <div class="text-subtitulo w-full" v-html="item.subtitulo"></div>
        </div>
      </div>
      <div :class="'solucoes w-full ' + (item.subtitulo != null && fc_removeHTML(item.subtitulo).trim() !== '' ? 'pt-0' : '')" v-if="(solucoes.loaded && solucoes.list.length > 0)">
        <div class="auto-container flex flex-wrap w-full">
          <ListItemSolucao v-for="(forItem, forIndex) in solucoes.list" :key="forIndex" :itemIndex="forIndex" :item="forItem" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ListItemSolucao from '@/components/ListItemSolucao.vue';
export default {
  components: {
    ListItemSolucao
  },
  data() {
    return {
      loaded: false,
      item: {},
      solucoes: {
        list: [],
        loaded: false,
      },
    };
  },
  props: {},
  computed: {},
  watch: {},
  methods: {
    mt_start() {
      this.mt_loadData();
    },
    mt_loadData() {
      this.fc_fetch({ endpoint: 'Solucoes/', method: 'GET', success: this.mt_loadData_success, error: () => { this.fc_goRoute('home'); } });
    },
    mt_loadData_success(response) {
      if (response != null && response.list != null) {
        this.solucoes.list = response.list;
      }
      this.solucoes.loaded = true;
      this.loaded = true;
    }
  },
  created() {},
  mounted() {
    let promises = [];
    promises.push(new Promise((resolve, reject) => { this.fc_fetch({ endpoint: 'SolucoesPagina/', method: 'GET', success: (response) => { this.item = response.item; resolve(); }, error: reject }); }));
    Promise.all(promises).then(() => { this.mt_start(); }).catch((e) => { this.fc_printErrors(e); });
  },
  unmounted() {},
};
</script>

<style scoped>
.solucoes-view {
  background-color: #f9f9f9 !important;
}
.solucoes {
  position: relative;
  padding: 70px 0px;
}
</style>
